module.exports = __webpack_public_path__ + "img/image_2.7afcae3f.jpg";